import * as React from 'react';

import { IAnalyticsData } from '../../types';
import { trackPromotionsLabelClick } from '../../utils/tracking/promotions';
import { mergeStyles } from '@cian/utils';
import { ICountrysidePromoItem } from '@cian/api-models/offer-card/v1/get-offer-data';

import * as styles from './PromotionsLabel.css';

export interface IPromotionsLabelStoreProps {
  promotionItem: ICountrysidePromoItem | null;
  analyticsData: IAnalyticsData;
  isEnabled?: boolean;
}

export class PromotionsLabel extends React.Component<IPromotionsLabelStoreProps> {
  public render() {
    const { promotionItem, isEnabled } = this.props;

    if (!isEnabled || !promotionItem || promotionItem.label.length > 35) {
      return null;
    }

    return (
      <div
        {...mergeStyles(styles['label'], styles[`background-${promotionItem.type}`])}
        onClick={this.onLabelCkick}
        title="Все акции"
      >
        {promotionItem.label}
      </div>
    );
  }

  private onLabelCkick = () => {
    const {
      promotionItem,
      analyticsData: { offer, village },
    } = this.props;
    if (promotionItem && village) {
      trackPromotionsLabelClick(promotionItem.type, offer.id, village.id);
    }

    const promotionList = document.getElementById('promotions');

    if (promotionList) {
      promotionList.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };
}
